export default {
  presenter: 'uhlik',
  title: 'VI [Esc] : s/$/M/',
  subtitle: 'začátečníci',
  text: `
Na praktických příkladech si vyzkoušíme nově nabyté znalosti a dovednostii z přednášky Základy
VIMu od Petra Hodače. Ukážeme si jak lze ve VIMu řešit některé věci daleko efektivněji v
porovnání s alternativními textovými editory. V závěru pak bude krátká ukázka konfiguračního
souboru .vimrc a dalších míst, kde můžeme zkrátky z VIMu uplatnit (VIMIUM, IdeaVIM, Ranger, ...).
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/uhlik-vi.js